import { useAuth } from '../hooks/useAuth';

const API_URL = process.env.REACT_APP_API_URL;


export const fetchBalaviharReportTypes = async (accessToken, reportParam) => {
      
  const response = await fetch(`${API_URL}/reports/${reportParam}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'x-cmdfw-jwt-token': `${accessToken}`,
      'Cache-Control': 'no-cache, no-store, must-revalidate', // Prevent caching
      'Pragma': 'no-cache', // Legacy HTTP/1.0 header
      'Expires': '0', // Expire immediately
    }
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Fetch Reports failed');
  }
  
  const data = await response.json();
  return { response, data }; // Fetch report types
}

export const runReport = async (accessToken, reportData, reportParam) => {
      
  const response = await fetch(`${API_URL}/reports/${reportParam}/run`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-cmdfw-jwt-token': `${accessToken}`,
    },
    body: JSON.stringify(reportData)
  });
  
  const data = await response.json();
  return { data, response }; // Run report
}

export const memberProfile = async (accessToken) => {
      
  const response = await fetch(`${API_URL}/graphql`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-cmdfw-jwt-token': `${accessToken}`,
    },
    body: JSON.stringify({
      query: `
        query {
          memProfile {
            primary {
              memberId
              memberType
              firstName
              lastName
              mobileNumber
              email
            },
            spouse {
                  memberId
                  memberType
                  firstName
                  lastName
                  mobileNumber
                  email
          },
          }
        }
      `,
    }),
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Member Profile failed');
  }
  
  const data = await response.json();
  return { response, data }; // Fetch event types
}

export const PostData = async (accessToken, endpointUrl, payload) => {
  const { handleLogout } = useAuth(); // Access handleLogout from AuthContext

  const response = await fetch(endpointUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-cmdfw-jwt-token': `${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      console.error('Unauthorized or Forbidden. Logging out...');
      handleLogout(); // Call handleLogout on 401 or 403
    }

    const errorData = await response.json();
    throw new Error(errorData.message || 'Member Profile request failed');
  }

  const data = await response.json();
  return { response, data };
};